export default "__VITE_ASSET__BkaNsanV__"